import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { DropDown, DropDownItem } from 'components/DropDown'
import { getMessage } from '../../../lib/translator'
import { SplitContext } from 'containers/SplitContext'
import SPLIT_FEATURES from 'containers/SplitContext/features'

export default function HeaderActions() {

  const splitConfig = useContext(SplitContext)
  const { splits } = splitConfig
  const isRuleExclusionsEnabled =
    splits[SPLIT_FEATURES.OFFER_ENABLE_RULE_EXCLUSIONS]?.treatment === 'on'
  const isMiraklExclusionsEnabled =
    splits[SPLIT_FEATURES.OFFER_ENABLE_MIRAKL_EXCLUSIONS]?.treatment === 'on'

  return (
    <>
      <Link to="/marketing/offers/add" className="primary button add-action">
        + <span className="text">{getMessage('offer.add.text')}</span>
      </Link>
      <Link
        to="/marketing/offers/pin-wallet/add"
        className="primary button add-action"
      >
        <span className="text">{getMessage('offer.pin.wallet')}</span>
      </Link>
      <DropDown
        className="exclusions-configurations-dropdown"
        icon={
          <button className="primary button">Exclusion Configurations</button>
        }
      >
        {
          isRuleExclusionsEnabled && (
            <DropDownItem>
              <Link to={'/marketing/offers/rule_exclusions'}>Rule Exclusions</Link>
            </DropDownItem>
          )
        }

        <DropDownItem>
          <Link to="/marketing/offers/sku_exclusions">
            {getMessage('offer.skuExclusions.route.button')}
          </Link>
        </DropDownItem>

        {
          isMiraklExclusionsEnabled && (
            <DropDownItem>
              <Link to="/marketing/offers/mirakl_exclusions">
                {getMessage('offer.miraklExclusions.route.button')}
              </Link>
            </DropDownItem>
          )
        }
      </DropDown>
    </>
  )
}
